$(document).ready(function() {
	if(!document.querySelector('.emp-type')) return false;
	
	let multiCountryName = "";
	let multiCountryCode = "";
	
	// LGEUK-124 Start
	const countryCode = $('html').data('countrycode').toUpperCase();
	let cookieA = false;
	
	var emailAddressDiff = '';
	
	// LGETH-120 Start
	// if(countryCode == 'TH'){
	// 	$("input:checkbox[id='signUp-chk1']").prop("checked", true);
	// 	$("input:checkbox[id='signUp-chk2']").prop("checked", true);
	// }
	// LGETH-120 End
	
	// LGEGMC-2449 Start
	let emailVerificationResult = false;
	// LGEGMC-2449 End
	
	//PJTJOINMEMBER-1 add
	let emailDupcheckResult = false;
	var emailAddressDiffV2 = '';
	const emailCertificationV2 = $('#empEmailcertificationV2').length > 0;
	const birthCheckFlag = $('#birthCheckFlag').length > 0;
	var limitAge = 0;
	if(typeof $('input[name=limitAgeBirth]').val() != 'undefined'){
		limitAge = parseInt($('input[name=limitAgeBirth]').val());
		if(birthCheckFlag && document.forms[0].id == 'accountCombineForm'){
			if($(' .ac-integration-terms').find('.field-block').length == 0) $(' .ac-integration-terms').hide();
		}
	}
	//PJTJOINMEMBER-1 add
	
	//LGCOMMON-8266 Start 페이지 진입시 birthDay 입력란에 초기세팅
	if ( document.forms[0].id == 'accountCombineForm' ) {
		if ( $('input[name=birthYmd]').length > 0 && $('input[name=birthDate]').length > 0 ) {
			if ( $('input[name=birthYmd]').val() != '' ) {
				var datePickerFormat = $('input[name=birthDate]').attr('data-date-format');
				var splitter = "/";
				if ( datePickerFormat.includes("/") ) {
					splitter = "/";
				} else if ( datePickerFormat.includes("-") ) {
					splitter = "-";
				} else if ( datePickerFormat.includes("_") ) {
					splitter = "_";
				}
				var datePickerFormatArr = datePickerFormat.split(splitter);
				var datePickerYMD = "";
				var datePickerY = $('input[name=birthYmd]').val().substring(0, 4);
				var datePickerM = $('input[name=birthYmd]').val().substring(4, 6);
				var datePickerD = $('input[name=birthYmd]').val().substring(6, 8);
				if ( datePickerFormatArr.length > 0 ) {
					for (i = 0; i < datePickerFormatArr.length ; i++) {
						if ( datePickerFormatArr[i] == "yy" ) {
							datePickerYMD += datePickerY;
						} else if ( datePickerFormatArr[i] == "mm" ){
							datePickerYMD += datePickerM;
						} else if ( datePickerFormatArr[i] == "dd" ){
							datePickerYMD += datePickerD;
						}
						datePickerYMD += splitter;
		    	    }
				}
				datePickerYMD = datePickerYMD.substring( 0 , datePickerYMD.length-1 );
	
				$('input[name=birthDate]').datepicker("setDate", datePickerYMD);
			}
		}
	}
	//LGCOMMON-8266 End	
	
	if(typeof ePrivacyCookies!='undefined' && ePrivacyCookies.get('LGCOM_ADVERTISING')){ // LGEITF-182
		cookieA = true;
	}
	console.log('treasuredata cookie flag : '+cookieA);
	if(cookieA){
		$('head').append('<!-- Treasure Data --><script type="text/javascript">!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.2/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);</script>');
	}	
	// LGEUK-124 End

	//LGCOMBR-45 Start
	if(countryCode == 'BR'){
		if("undefined" === typeof(_etmc)){
			$('head').append('<script type="text/javascript" async src="//534007295.collect.igodigital.com/collect.js"></script>');
		}else if(Array.isArray(_etmc)){
			$('head').append('<script type="text/javascript" async src="//534007295.collect.igodigital.com/collect.js"></script>');
		}
	}
	//LGCOMBR-45 End
	
	const form = {
		el: document.forms,
		$selectors: null,
		systemErrMsg: document.querySelector('.system-error'),
		signup: document.getElementById("signUpEmpForm"), //LGEBR-1275
		viewPasswordFlag : "N", //LGEBR-1275
		sendSignUpFlag : "N", //LGCOMMON-10757
		init: function(){
			form.vnLangCheck();
			form.setBirthday();
			form.addEvent();
			form.$selectors = $(form.el).find('select');
			form.getCaptcha();
			form.viewPasswordRule();
			form.viewPasswordFlag = $(form.signup).find('[name="viewPasswordFlag"]').val(); //LGEBR-1275
			
			// LGECI-824 LGEIS-978
			if(countryCode == 'CA_EN' || countryCode == 'CA_FR' || countryCode == 'IT' || birthCheckFlag == true) {
				$('.chk-info').addClass('show');
			}
		},
		setBirthday: function(){
			if ($('[name=birthDate]').data('ageLimit') != '' &&  $('[name=birthDate]').data('ageLimit') != 'undefined'){
				const ageLimit = $('[name=birthDate]').data('ageLimit');
				if ( ageLimit == 0) {
					$('#birthDate').datePicker('setEndDate', '0y' );
				} else {
					// LGEIS-1168 : SNS 회원가입 시 IT의 경우 생일 필드 제한 나이로 설정 막음
					if(countryCode == 'IT' && $('#snsSignUpForm')){	
						$('#birthDate').datePicker('setEndDate', '0y' );
					}else {
						$('#birthDate').datePicker('setEndDate', '-' + ( ageLimit + 1 ) + 'y' );
					}
				}
			}
		},
		vnLangCheck: function(){
			// VN korean check
			const lang = $('html').attr('lang');
			if (countryCode == 'VN' && lang == 'KR'){
				$(form.el).append( '<input type="hidden" name="langType" value="kr">' );
			}
		},
		toastMsg:function(){			
			// Toast Message
			const $form = $(form.el);
			const $signupCompleteToast = $("#signupCompleteToast");
			if ($form.data('completeMessage')) {
				$signupCompleteToast.find('.toast-body').text($form.data('completeMessage'));
			} else {
				$signupCompleteToast.find('.toast-body').html('Sign Up Complete');
			}
			$signupCompleteToast.toast('show');
		},
		appendCaptcha: function(html){
			$('#captchaBox').empty();
			$('#captchaBox').append(html);
		},
		getCaptcha: function( showErrorCbFn ){
			if (typeof showErrorCbFn !== 'function'){
				showErrorCbFn = new Function();
			}
			const $form = $(form.el);
			const captchaUrl = $form.data('captchaUrl');
			if(!captchaUrl) return false;

			$.ajax({
				type: "post",
				url: captchaUrl,
				async: false,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					// console.log(data);
					//$(sgin.el).attr("data-action-url", data.captchaUrl).data("actionUrl", data.captchaUrl);
					if (!!data.captchaHtml){
						let $csrf;
						if ( $form.find('[name=csrfToken]').length ){
							$csrf = $form.find('[name=csrfToken]').eq(0);
							$csrf.val( data.csrfToken );
						} else {
							$csrf = $('<input type="hidden" name="csrfToken">');
							$csrf.val( data.csrfToken );
							$form.append( $csrf );
						}
						
						form.appendCaptcha(data.captchaHtml);
						showErrorCbFn();
						
					}
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);

					alert('SYSTEM ERROR');
				}
			});


		},
		// EMP 20220128 START 박지영 - 비밀번호 규칙 내용 여닫기 기능 추가
		viewPasswordRule:function(){
			$('.password-info button[aria-expanded]').on('click', function() {
				const $button = $(this),
					$cont = $button.closest('.password-info').find('.password-info-cont');

				if ($cont.is(':visible')) {
					$button.attr('aria-expanded', false);
					$cont.stop().slideUp();
				} else {
					$button.attr('aria-expanded', true);
					$cont.stop().slideDown();
				}
			});
		},
		showError: function(_t, _target, _msg){
			const block = $(_t).parents(".field-block");

			if ( block.find(_target).length == 0 && _target == '.ajax-msg' ){
				block.find('.error-msg').append('<span class="ajax-msg"></span>');
			}		 
			showAndHideElements(block.find('.error-msg'), 'show', 'error-msg');
			block.addClass('error').find(_target).text(_msg).show().siblings().hide();
			$(_t).focus();
			if($(_t).hasClass('datepicker-input')){	// LGEIS-1168 : focus 이벤트 발생시 datepicker인 경우 달력이 error msg를 가려 focus 후 달력 팝업 닫음
				$(_t).datepicker("hide");
			}
		},
		beforeSubmit: function(e){
			e.preventDefault();
			
			if(emailAddressDiff != '' && emailAddressDiff != $('#txtBoxVerificationEmail').val()){
				$('#divVerificationBtnArea').show();
				$('#txtBoxVerificationCode').val('');
				$('#btnConfirmVerification').prop('disabled', false);
			
				if(!$('#emailAddressDiff').length){
					var message = !!$('#txtBoxVerificationEmail').data('diff-error-text') ? $('#txtBoxVerificationEmail').data('diff-error-text') : 'Please verify the email address';
					var close = !!$('#txtBoxVerificationEmail').data('close-text') ? $('#txtBoxVerificationEmail').data('close-text') : 'Close';
					
					var modalHtml = '<div class="modal modal-simple fade" id="emailAddressDiff" tabindex="-1" role="dialog" data-backdrop="false" aria-describedby="emailAddressDiffDialog">'; 
					modalHtml += 	    '<div class="modal-dialog" role="document">';
					modalHtml +=	        '<div class="modal-content">';
					modalHtml +=	            '<div class="modal-body">';
					modalHtml +=	                '<div class="simple-content-box"><div class="content-paragraph" id="emailAddressDiffDialog">'+message+'</div></div>';
					modalHtml +=		        '</div>';
					modalHtml +=		        '<div class="modal-footer">';
					modalHtml +=	                '<button type="button" class="btn btn-primary" data-dismiss="modal">'+close+'</button>';
					modalHtml +=	            '</div>';
					modalHtml +=	        '</div>';
					modalHtml +=	    '</div>';
					modalHtml +=	'</div>';
					
					$('body').append(modalHtml)
				}
				
				/* Confirmed 활성화 */
				$('#txtBoxVerificationCode').attr('disabled', false);
				$('#divVerificationErrorMsg').find('.ajax-msg').removeClass('confirmed').hide();
				
				/* 이메일 확인 결과 저장 */
				emailVerificationResult = true;
				
				$('#emailAddressDiff').modal();
				
				return false;
			}
			
			if(emailCertificationV2 && (!emailDupcheckResult || (emailAddressDiffV2 != '' && emailAddressDiffV2 != $('#txtBoxVerificationEmail').val()))){
				$('.emp-email-certification').find('.left-area').find('.label-animation-input').addClass('error');
				$('#txtBoxVerificationEmail').focus();
				showAndHideElements($(".emp-email-certification").find('.error-msg'), 'show', 'check-required');
				return false;
			} 
			
			/* LGEGMC-4766,LGEGMC-5323 start */
        	if( $("#g-recaptcha").length > 0 && $('#g-sitekey').length > 0 && $("#useNewCaptchaView").length > 0 && $("#useNewCaptchaView").val() == "N"){
				var reCaptcha_Key = $('#g-sitekey').val();
	        	grecaptcha.enterprise.ready(function() {
	        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: document.forms[0].id}).then(function(token) {
	        			$("#g-recaptcha").val(btoa(token));
	        			sendSignUp();
	        		});
	        	});
			}else{
				sendSignUp();
			}
			/* LGEGMC-4766,LGEGMC-5323 end */
			
        	function sendSignUp(){
        		//LGCOMMON-10757 start
        		if(form.sendSignUpFlag == 'Y'){
        			return;
        		}
        		
        		form.sendSignUpFlag = 'Y';
        		//LGCOMMON-10757 end
				const _this = e.currentTarget;
				const url = _this.getAttribute('data-url');
				
				let param = $(_this).serialize();	// form data
				// LGEITF-182 Start
				param+='&tdloginType=normal'; // LGEUK-124
				param+='&treasureType=signup';
				// LGEITF-182 End
				// LGEITF-491 start
				if( $(".emp-verification-code").find("input").length > 0){
					param+='&verificationCode=' + $(".emp-verification-code").find("input").val();	
				}
				// LGEITF-491 end
				if($(_this).checkValidation()) {
					/* 이메일 인증되지 않으면 */
					if ($('.emp-email-certification').find('input').length != 0) {
						//PJTJOINMEMBER-3
						if(!emailCertificationV2){
							if (!emailVerificationResult) {
								showAndHideElements($('.emp-verification-code').find('.error-msg'), 'show', 'required');
								return;
							}
						}else{
							if(!emailDupcheckResult){	
								showAndHideElements($('.emp-email-certification').find('.error-msg'), 'show', 'required');
								return;
							}
						}
						//PJTJOINMEMBER-3
					}
					
					if(birthCheckFlag && $('input[name=birthDate]').length > 0){
						if(!dateScope.dateValidation($('input[name=birthDate]').val())){
							showAndHideElements($('.select-birth').parent().find('.error-msg'), 'show', 'invalid');
							$('#txtBoxBirthY').focus();
							return;
						}else{
							var cDay = $('#txtBoxBirthD').val();
							cDay = parseInt(cDay) > 0 && parseInt(cDay) < 10 && cDay.length == 1 ? '0'+ cDay : cDay;
							if(!dateScope.limitAgeCheck($('#txtBoxBirthY').val(),$('#txtBoxBirthM option:selected').val(),cDay,limitAge)){
								showAndHideElements($('.select-birth').parent().find('.error-msg'), 'show', 'limitAge');
								$('#txtBoxBirthY').focus();
								return;
							}
						}
						
					}
	
					$('body').trigger('ajaxLoadBefore');
					if(document.forms[0].id == 'snsSignUpForm'){
						//$('.btn-area').find('button[type=submit]').attr('disabled', true);
						var chked_val = "";
						$("input[name*='policy_name_list']:checked").each(function(pi,po) {
							chked_val += ","+po.value;
						});
						if(chked_val!="") chked_val = chked_val.substring(1);
						param+='&policyNameList='+chked_val;
						
						/*if($("input[name='policy_name_list empOptionalAgreementFlag']").prop("checked")){
	                        chked_val += ","+$("input[name='policy_name_list empOptionalAgreementFlag']").val();
	                    }
	                    if($("input[name='policy_name_list empProfileOptionalFlag']").prop("checked")){
	                    	chked_val += ","+$("input[name='policy_name_list empProfileOptionalFlag']").val();
	                    }*/
						
						$.ajax({
							type: 'post',
							url: url,
							data: param,
							dataType: 'json',
							xhrFields: {
								withCredentials: true
							},
							success: function(data) {
								form.sendSignUpFlag = 'N'; //LGCOMMON-10757
								if(data.status == 'success') {
									form.toastMsg();
									$(_this.submitData).val( JSON.stringify( data ) );
									
									//LGEGMC-4064 start
									if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
										setTimeout(function(){
											treasuredataInit(data, 'signUpNomalSubmit',_this);
										},3000);
										$('body').trigger('ajaxLoadEnd');
									}else{
										setTimeout(function(){
											//LGCOMITF-123-2 start
											if ( cookieA ) {
												nonTreasureDataInsertTable(data);
											}
											//LGCOMITF-123-2 end
											_this.submit();
										},3000);
									}
									//LGEGMC-4064 end
									$('body').trigger('ajaxLoadBefore');
									//LGEGMCGA-11 START
									window.dataLayer.push({
										event: 'register_complete',
										register_type: data.typeSocial									
									});
									//LGEGMCGA-11 END
									//LGCOMBR-45 Start
									if(countryCode == 'BR'){
										var userEmailAddr = findSerialize($(_this).serializeArray(),"emailAddr");
										_etmc.push(["setOrgId","534007295"]);
										_etmc.push(["setUserInfo",{"email":userEmailAddr}]);
										_etmc.push(["trackPageView"]);
									}
									//LGCOMBR-45 End
								} else if(data.status == 'fail') {
									if(data.error.code == "401") {
										$('.emp-verification-code').find('.error-msg').find('.ajax-msg').html(data.error.message);
										showAndHideElements($('.emp-verification-code').find('.error-msg'), 'show', 'ajax-msg');
										$('.emp-email-certification').find("input").focus();
									}else if(data.error.code == "2004"){
										$('.snspassword').find('.left-area').find('.label-animation-input').addClass('error');
										$('.snspassword').find('.error-msg').find('.fail-to-combination').show();
									}else if(data.error.birthDate){	// LGEIS-1168
										if(birthCheckFlag && $('#txtBoxBirthD').length > 0){
											var bBlock = $('#txtBoxBirthD').parents(".field-block");
											showAndHideElements(bBlock.find('.error-msg'), 'show', 'limitAge');
										}else{
											const block = $('#birthDate').parents(".field-block");
											block.find('.error-msg').find('.ajax-msg').html(data.error.message);
											showAndHideElements(block.find('.error-msg'), 'show', 'ajax-msg');
										}
									}
	
									// LGEITF-182, LGEGMC-4064 Start
									if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
										let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
										if(window.location.href.indexOf('/oauth/') >=0) {
											const actionURL = (_this.getAttribute('data-url').length>0) ? _this.getAttribute('data-url') : null;
											if(actionURL.indexOf('wdev50.lg.com')>=0) {
												tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
											} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
												tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
											} else if(actionURL.indexOf('www.lg.com')>=0){
												tdFailUrl="https://www.lg.com"+tdFailUrl;
											}else{
												tdFailUrl="https://"+window.location.host+tdFailUrl;
											}
										}
										$.ajax({
												type: 'post',
												url: tdFailUrl,
												dataType: 'json',
												data: param,
												xhrFields: {
													withCredentials: true
												},
												async: false,
												success: function(failData) {
													if(data.error.tdMessage){
														failData["failMessage"]=data.error.tdMessage;
													}else{
														failData["failMessage"]=data.error.message;
													}
													// 
													if(data.error.tdTypeFail){
														failData["tdTypeFail"]=data.error.tdTypeFail;
													}
													treasuredataInit(failData,'FAIL');
												},
												error: function(request,status,error) {
													console.log("status: "+status);
													console.log("error: "+error);
													$('body').trigger('ajaxLoadEnd');
												}
										});
									//LGCOMITF-123-2 start
									} else if ( cookieA ) {
										let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
										if(window.location.href.indexOf('/oauth/') >=0) {
											const actionURL = (_this.getAttribute('data-url').length>0) ? _this.getAttribute('data-url') : null;
											if(actionURL.indexOf('wdev50.lg.com')>=0) {
												tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
											} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
												tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
											} else if(actionURL.indexOf('www.lg.com')>=0){
												tdFailUrl="https://www.lg.com"+tdFailUrl;
											}else{
												tdFailUrl="https://"+window.location.host+tdFailUrl;
											}
										}
										$.ajax({
												type: 'post',
												url: tdFailUrl,
												dataType: 'json',
												data: param,
												xhrFields: {
													withCredentials: true
												},
												async: false,
												success: function(failData) {
													if(data.error.tdMessage){
														failData["failMessage"]=data.error.tdMessage;
													}else{
														failData["failMessage"]=data.error.message;
													}
													// 
													if(data.error.tdTypeFail){
														failData["tdTypeFail"]=data.error.tdTypeFail;
													}
													nonTreasureDataInsertTable(failData);
												},
												error: function(request,status,error) {
													console.log("status: "+status);
													console.log("error: "+error);
													$('body').trigger('ajaxLoadEnd');
												}
										});
									}
									// LGEITF-182, LGEGMC-4064 End	//LGCOMITF-123-2 end
									$('body').trigger('ajaxLoadEnd');
								}
								$(form.systemErrMsg).removeClass("show");
							},
							error: function(request,status,error) {
								form.sendSignUpFlag = 'N'; //LGCOMMON-10757
								$(form.systemErrMsg).addClass("show");
								$('body').trigger('ajaxLoadEnd');
							},
							complete: function(){
							
							}
						});
					} else if(document.forms[0].id == 'accountCombineForm') {
						// 계정 통합 페이지
						var chked_val = "";
						$("input[name*='policy_name_list']").each(function(pi,po) {
							chked_val += ","+po.value;
						});
						if(chked_val!="") chked_val = chked_val.substring(1);
						param+='&policyNameList='+chked_val;
						
						var unChked_val = "";
						$("input[name='policy_name_list']:not(':checked')").each(function(pi,po) {
							unChked_val +=  "," + po.value;
						});
						if(unChked_val!="") unChked_val = unChked_val.substring(1);
						param+='&unPolicyNameList='+unChked_val;
	
						// LGEGMC-3436Start
						// 회원가입 여부 true : 기가입 고객 중 emp 계정 통합 페이지 진입 시 케이스
						if(personalToastUseFlag){		//LGEITF-931
							gnbPersonal.update('membership', true);
							gnbPersonal.removeFirstSession();
						};
						// LGEGMC-3436 End
	 
						//PJTGPEMP-31
						if($('#nameType2').length) {
							param+='&changeLocaleCode='+"Y";
						}
						
						$.ajax({
							type: 'post',
							url: url,
							data: param,
							dataType: 'json',
							xhrFields: {
								withCredentials: true
							},
							success: function(data) {
								form.sendSignUpFlag = 'N'; //LGCOMMON-10757
								if(data.status == 'success') {
									location.href = data.returnUrl;
								} else if(data.status == 'fail') {
									if(data.error.code == "501") {
										$('.emp-verification-code').find('.error-msg').find('.ajax-msg').html(data.error.message);
										showAndHideElements($('.emp-verification-code').find('.error-msg'), 'show', 'ajax-msg');
										$('.emp-email-certification').find("input").focus();
									}
									else if(data.error.code == "500") {
										// system error
										const $errorModal = $("#modalEmpAlert");
										if (data.error.message) {
											$errorModal.find('.content-paragraph').html(data.error.message);
										} else {
											$errorModal.find('.content-paragraph').html('Integration failed due to system error.<br>Please try again.');
										}
										$errorModal.modal('show'); 
									}
									else if(data.error.code == 'birthError'){	// LGEIS-1168
										if(birthCheckFlag && $('#txtBoxBirthD').length > 0){
											var bBlock = $('#txtBoxBirthD').parents(".field-block");
											showAndHideElements(bBlock.find('.error-msg'), 'show', 'limitAge');
										}else{
											const block = $('#birthDate').parents(".field-block");
											block.find('.error-msg').find('.ajax-msg').html(data.error.message);
											showAndHideElements(block.find('.error-msg'), 'show', 'ajax-msg');
										}
									}
									
									$('body').trigger('ajaxLoadEnd');
								}
								$(form.systemErrMsg).removeClass("show");
							},
							error: function(request,status,error) {
								form.sendSignUpFlag = 'N'; //LGCOMMON-10757
								$(form.systemErrMsg).addClass("show");
								$('body').trigger('ajaxLoadEnd');
							},
							complete: function(){
							}
						});
						
					} else if (document.forms[0].id == 'signUpEmpForm') {
						//$('.btn-area').find('button[type=submit]').attr('disabled', true);
						$.ajax({
							type: 'post',
							url: url,
							data: param,
							dataType: 'json',
							xhrFields: {
								withCredentials: true
							},
							success: function(data) {
								form.sendSignUpFlag = 'N'; //LGCOMMON-10757
								// LGEHK-204 START
								if(data.migrationFlag == 'undefined' || data.migrationFlag == null){
									if (data.status != 'success') {
										// LGECI-541 start
										if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
											if( !!$('#g-recaptcha').val()){
												//PJTJOINMEMBER-1 add
												if(COUNTRY_CODE == 'ca_en' || COUNTRY_CODE == 'ca_fr'){
													reload_recaptcha_wrapper();
												}
											}
										}
										// LGECI-541 end
										
										// LGEPA-473 start : test
		
										if( data.error.code == "1009"){ // LGEGMC-2186
											
											let _htm = "<form action='' id='signUpEmpForm' method='post'>"
												_htm += "<fieldset>";
												_htm += "<input type='hidden' id='txtBoxVerificationEmail' name='emailAddr' value='"+data.error.mail+"'>";
												_htm += "<input type='hidden' id='txtBoxPassword' name='password' value='abc1234!@'>";
												_htm += "<input type='hidden' name='submitData' value='"+ JSON.stringify( data )+"'>";
												_htm += "<input type='hidden' name='serverEnv' value='"+$("#signUpEmpForm").find("input[name='serverEnv']").val()+"'>";
												_htm += "</fieldset>";
												_htm += "</form>";
												
											$('body').append(_htm);
											const loginform = $("#signinForm");
											loginform.attr("action",$("#signUpEmpForm").attr("action").replace("/signUp","/login"));
											loginform.submit();
											return;	        					
										}
										// LGEPA-473 start : end
		
										// LGEGMC-2449 start
										if ((data.error.code == "1002" || data.error.code == "2002") && $('.emp-verification-code').find('.error-msg').length != 0) {
											$('.emp-verification-code').find('.error-msg').find('.ajax-msg').html(data.error.message);
											showAndHideElements($('.emp-verification-code').find('.error-msg'), 'show', 'ajax-msg');
										}
										// LGEGMC-2449 end
		
										// LGEGMC-2112 Start
										if ((data.error.code == "1002" || data.error.code == "2002") && $('#signinEmailSendFieldBlock').length != 0) {
											const $emailFieldBlock = $('#signinEmailSendFieldBlock');
		
											$emailFieldBlock.find('.error-msg .ajax-msg').text(data.error.message).show();
		
											$emailFieldBlock.addClass('error');
											$emailFieldBlock.find('.error-msg').show();
										}
										// LGEGMC-2112 end
										
										// LGEITF-182, LGEGMC-4064 Start
										if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
											let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
											if(window.location.href.indexOf('/oauth/') >=0) {
												const actionURL = (_this.getAttribute('data-url').length>0) ? _this.getAttribute('data-url') : null;
												if(actionURL.indexOf('wdev50.lg.com')>=0) {
													tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
												} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
													tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
												} else if(actionURL.indexOf('www.lg.com')>=0){
													tdFailUrl="https://www.lg.com"+tdFailUrl;
												}else{
													tdFailUrl="https://"+window.location.host+tdFailUrl;
												}
											}
											$.ajax({
													type: 'post',
													url: tdFailUrl,
													dataType: 'json',
													data: param,
													xhrFields: {
														withCredentials: true
													},
													async: false,
													success: function(failData) {
														if(data.error.tdMessage){
															failData["failMessage"]=data.error.tdMessage;
														}else{
															failData["failMessage"]=data.error.message;
														}
														// 
														if(data.error.tdTypeFail){
															failData["tdTypeFail"]=data.error.tdTypeFail;
														}
														treasuredataInit(failData,'FAIL');
													},
													error: function(request,status,error) {
														console.log("status: "+status);
														console.log("error: "+error);
														$('body').trigger('ajaxLoadEnd');
													}
											});
										//LGCOMITF-123-2 start
										} else if ( cookieA ) {
											let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
											if(window.location.href.indexOf('/oauth/') >=0) {
												const actionURL = (_this.getAttribute('data-url').length>0) ? _this.getAttribute('data-url') : null;
												if(actionURL.indexOf('wdev50.lg.com')>=0) {
													tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
												} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
													tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
												} else if(actionURL.indexOf('www.lg.com')>=0){
													tdFailUrl="https://www.lg.com"+tdFailUrl;
												}else{
													tdFailUrl="https://"+window.location.host+tdFailUrl;
												}
											}
											$.ajax({
													type: 'post',
													url: tdFailUrl,
													dataType: 'json',
													data: param,
													xhrFields: {
														withCredentials: true
													},
													async: false,
													success: function(failData) {
														if(data.error.tdMessage){
															failData["failMessage"]=data.error.tdMessage;
														}else{
															failData["failMessage"]=data.error.message;
														}
														// 
														if(data.error.tdTypeFail){
															failData["tdTypeFail"]=data.error.tdTypeFail;
														}
														nonTreasureDataInsertTable(failData);
													},
													error: function(request,status,error) {
														console.log("status: "+status);
														console.log("error: "+error);
														$('body').trigger('ajaxLoadEnd');
													}
											});
										}
										// LGEITF-182, LGEGMC-4064 End	//LGCOMITF-123-2 end
		
										if (!data.error) {
											// system error
											const $errorModal = $("#errorModal");
		
											if (data.errorMessage) {
												$errorModal.find('.content-paragraph').html(data.errorMessage);
											} else {
												$errorModal.find('.content-paragraph').html('Sign up failed due to system error.<br>Please try again.');
											}
		
											$errorModal.modal('show'); 
										} else {
											// validation fail
											form.getCaptcha(function(){
												for (var key in data.error) {
													const $field = $(_this).find('input[name="' + key + '"]');
													
													if ($field.length) {
														form.showError($field, '.ajax-msg', data.error[key]);
													}
												}
											});
											//LGEITF-561 start
											if($('[name=countryCode]').val() == 'CA' && $('.guide-password').length > 0){
												for (var key in data.error) {
													const $field = $(_this).find('input[name="' + key + '"]');
													if ($field.length) {
														form.showError($field, '.ajax-msg', data.error[key]);
														if(key=="password" && $field.parent().find('.error-msg').children('.guide-password').length > 0){ 
															showAndHideElements($('input[name=password]').parent().find('.error-msg'), 'show', 'guide-password');
														}
													}
												}
											}
											//LGEITF-561 end
											// LGEGMC-2112 Start
											if ($('.emp-verification-code').find('.error-msg').length != 0) {
												$('.emp-verification-code').find('.error-msg').find('.ajax-msg').html(data.error.message);
												showAndHideElements($('.emp-verification-code').find('.error-msg'), 'show', 'ajax-msg');
											}
											// LGEITF-182 End
										}
		
										$('body').trigger('ajaxLoadEnd');
									} else {
										// successed
										// 20200406 START 김우람 || TH 가입후 설문조사 분기 추가 
										if (!!data.surveyFlag) {
											const authorizeKey = getUrlParams().authorizeKey;
											// 200421 START 전호근 - parameter 수정
											window.location.href = data.surveyUrl + '&authorizeKey=' + authorizeKey;
											// 200421 END 전호근 - parameter 수정
		
											$('body').trigger('ajaxLoadEnd');
										} else {
	
											$(_this.submitData).val( JSON.stringify( data ) );
											// LGEUK-124 Start
											if(typeof captcha == "undefined"){
												if(!emailCertificationV2) form.toastMsg(); //PJTJOINMEMBER-3
	
												//LGEGMC-4064 start
												if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
													setTimeout(function(){
														treasuredataInit(data, 'signUpNomalSubmit',_this);
													},3000);
													$('body').trigger('ajaxLoadEnd');
												}else{
													setTimeout(function(){
														//LGCOMITF-123-2 start
														if ( cookieA ) {
															nonTreasureDataInsertTable(data);
														}
														//LGCOMITF-123-2 end
														_this.submit();
													},3000);
												}
												//LGEGMC-4064 end
											}else{
												if(captcha && captcha.validation()){
													if(!emailCertificationV2) form.toastMsg(); //PJTJOINMEMBER-3
	
													//LGEGMC-4064 start
													if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
														setTimeout(function(){
															treasuredataInit(data, 'signUpNomalSubmit',_this);
														},3000);
														$('body').trigger('ajaxLoadEnd');
													}else{
														setTimeout(function(){
															//LGCOMITF-123-2 start
															if ( cookieA ) {
																nonTreasureDataInsertTable(data);
															}
															//LGCOMITF-123-2 end
															_this.submit();
														},3000);
													}
												}
											}
											// LGEUK-124 End
										}
										// 20200406 END 김우람 || TH 가입후 설문조사 분기 추가 
		
										/* dataLayer */
										// LGEUK-366, LGEIN-531, LGEGMCGA-11 Start
										if ($('.emp-email-certification').find('input').length != 0) {
											window.dataLayer.push({
												event: 'register_complete',
												register_type: 'web'
											});
											//LGEGMCGA-11 END
											//LGCOMBR-45 Start
											if(countryCode == 'BR'){
												var userEmailAddr = findSerialize($(_this).serializeArray(),"emailAddr");
												_etmc.push(["setOrgId","534007295"]);
												_etmc.push(["setUserInfo",{"email":userEmailAddr}]);
												_etmc.push(["trackPageView"]);
											}
											//LGCOMBR-45 End
										}
										// LGEITF-643 ADD
										$('body').trigger('ajaxLoadBefore');
									}
								} else {
								
									if(data.status != null && data.redirectUrl != ''){
										location.href = data.redirectUrl;
									}
									
								}
								$(form.systemErrMsg).removeClass("show");
								// LGEHK-204 END
							},
							error: function(request,status,error) {
								form.sendSignUpFlag = 'N'; //LGCOMMON-10757
								$(form.systemErrMsg).addClass("show");
								$('body').trigger('ajaxLoadEnd');
							},
							complete: function(){
							}
						});
					} 
				} else {
					// LGEGMC-2112 Start
					// CA 국가의 경우 required 클래스가 없고 guide-password 임
					if ($("input[name=password]").val() == '' && $('[name=countryCode]').val() == 'CA') {
						showAndHideElements($("input[name=password]").parent().find('.error-msg'), 'show', 'guide-password');
					}
	
					if ($('select[name=countryCode]').val() == 'AR') {
						if ($('#txtBoxDocumentNumber') == '' || $(_this).val() == null) {
							showAndHideElements($('#txtBoxDocumentNumber').parent().find('.error-msg'), 'show', 'required');
						} else if (!/^[0-9]+$/.test($('#txtBoxDocumentNumber').val())) {
							showAndHideElements($('#txtBoxDocumentNumber').parent().find('.error-msg'), 'show', 'required-num');
						} else if ($('#txtBoxDocumentNumber').val().length != $('#txtBoxDocumentNumber').attr('minlength')) {
							showAndHideElements($('#txtBoxDocumentNumber').parent().find('.error-msg'), 'show', 'min-length invalid');
						}
					}
					// LGEGMC-2112 End
				}
        	}
        	//LGCOMBR-45 Start
        	function findSerialize( values, k ) {
        	    var returnValue = "";
        	    var found = false;
        	    for (i = 0; i < values.length && !found; i++) {
        	        if ( values[i].name == k ) {
        	            returnValue = values[i].value;
        	            found = true;
        	        }
        	    }
        	    return returnValue;
        	}
        	//LGCOMBR-45 End
		},
		addEvent: function(){
			$(form.el).on({
				submit: form.beforeSubmit
			});

			// 20200416 START 김우람 || SG 선호하는 연락수단 기능 추가
			$(form.el).find('.priority-list input').on('keydown', function(e) {
				const availables = [8,9,37,39,46,49,50,51,52,97,98,99,100];

				if (!(availables.indexOf(e.keyCode)+1)) return e.preventDefault();
			});

			$(form.el).find('.priority-list input').on('keyup', function(e) {
				$(this).val($(this).val().replace( /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' ));
			});

			$(form.el).find('.priority-list input').on('blur', function(e) {
				const $this = $(this);
				const $siblings = $this.closest('.priority-list').find(':input').not($this);
				const $modal = $('#priorityAlertModal');
				const _val = $this.val() || null;

				$siblings.each(function(idx, field) {
					if ($(field).val() === _val) { 
						$this.val('');
						$modal.modal('show');
					}
				});
			});

			$(form.el).on('submit.priority', function() {
				const $fields = $('.priority-list input');
				let userValues = ['1','2','3','4'];

				$fields.each(function(idx, field) {
					const _idx = userValues.indexOf($(field).val());
					if (_idx+1) {userValues.splice(_idx, 1);}
				});
				$fields.each(function(idx, field) {
					if (!$(field).val()) {$(field).val(userValues.shift())}
				});
			});
			// 20200416 END 김우람 || SG 선호하는 연락수단 기능 추가

			$(form.el).on({
				"change.base": function(){
					form.$selectors.trigger('chosen:updated');
				}
			});
			
			// GP All Case | NL

			// checkbox 체크 시, input readonly 추가
			$(form.el).on({
				change: function(e){
					const _this = e.target,
						$target = $(_this.getAttribute("data-same-as-id"));

					!$target.data("isRequired") && $target.data("isRequired", $target.prop("required")); // 처음 한번만 실행

					if(_this.checked){
						$target.removeAttr("required");
						$target.val("").attr("readonly","readonly");
					}else{
						$target.data("isRequired") && $target.attr("required", "required");
						$target.removeAttr("readonly");
					}
				}
			}, '.same-as-input');

			// BR 개인/기업 선택
			$(form.el).on('click', '[data-personCheck]', function(){
				const select = $(this).attr('data-personCheck');
				// 20200311 START 김우람 || BR physical legal 버그 수정

				$('[data-personColumn]').find('.field-block').removeClass('error').end().find('.error-msg span').hide(); // LGEBR-829

				switch (select) {
					case 'Individual' :
						$('[data-personColumn="Individual"]').find('input[type="text"]').prop('disabled', false);
						$('[data-personColumn="legal"]').find('input[type="text"]').val('').prop('disabled', true).end().find('[data-freeCheck="checkbox"]').hide();
					break;
					case 'legal' :
						$('[data-personColumn="legal"]').find('input[type="text"]').prop('disabled', false).end().find('[data-freeCheck="checkbox"]').show();	
						$('[data-personColumn="Individual"]').find('input[type="text"]').val('').prop('disabled', true);
					break;
				}
				// 20200311 END 김우람 || BR physical legal 버그 수정
			});
			$(form.el).on('click', '[data-freeCheck="select"] > input[type="checkbox"]', function(){
				const field = $('[data-freeCheck="input"]');
				const text =  $(this).parent().find('.text').text();

				if($(this).prop('checked') == true){
					field.prop('readonly', true).val(text);
				}else{
					field.prop('readonly', false).val('');
				}
			});

			//Start LGEGMC-2112
			const $calendar = $(".datepicker-wrap");
			const $calendarInput = $calendar.find("input");
			if ($calendarInput.length != 0) {
				$calendarInput.on('change', function(e) {
					const $fb = $calendarInput.parent().parent();
					showAndHideElements($fb.find('.error-msg'), 'hide', '');
					if ($fb.hasClass("error")) {
						$fb.removeClass("error");
					}
				});
			}
			
			//PJTJOINMEMBER-1 add
			const $txtBoxBirthM = $('#txtBoxBirthM');
			if($txtBoxBirthM.length > 0){
				$txtBoxBirthM.on('change', function(e) {
					if($('#txtBoxBirthM option:selected').val() != '00'){
						const dateInfo = {
							year : 	$('#txtBoxBirthY').val(),
							month : $('#txtBoxBirthM option:selected').val(),
							day : $('#txtBoxBirthD').val()
						};
						dateInfo.day = parseInt(dateInfo.day) > 0 && parseInt(dateInfo.day) < 10  && dateInfo.day.length == 1 ? '0'+dateInfo.day : dateInfo.day;
						
						if(dateInfo.year != null && dateInfo.year != '' && dateInfo.day != null && dateInfo.day != ''){
							let checkBirth = dateInfo.year+dateInfo.month+dateInfo.day;
							if(dateScope.dateValidation(checkBirth)){
								if(!dateScope.limitAgeCheck(dateInfo.year,dateInfo.month,dateInfo.day,limitAge)){
									showAndHideElements($txtBoxBirthM.parent().parent().parent().find('.error-msg'), 'show', 'limitAge');
								}else{
									$('input[name=birthDate]').val(checkBirth);
									showAndHideElements($txtBoxBirthM.parent().parent().parent().find('.error-msg'), 'hide', 'required');
								}
										
					        }else{
					            showAndHideElements($txtBoxBirthM.parent().parent().parent().find('.error-msg'), 'show', 'invalid');
					        } 
						}
					}else{
						showAndHideElements($txtBoxBirthM.parent().parent().parent().find('.error-msg'), 'show', 'required');
					}
					
				});
				
				if(document.forms[0].id == 'accountCombineForm'){
					if(typeof $('input[name=birthDate]').val() != 'undefined' && $('input[name=birthDate]').val() != ''){
					    var birthArr = $('input[name=birthDate]').val().split('/');
					    if(birthArr.length == 3){
					    	var dayfomat = (typeof $('input[name=jaDaFormat]').val() != 'undefined' ? $('input[name=jaDaFormat]').val(): 'mm/dd/yyyy').split('/');
					    	var curCusDate = [];
					    	for(var di = 0; di < dayfomat.length; di++){
					    		if(dayfomat[di] == 'mm'){
					    			$('#txtBoxBirthM').val(birthArr[di]).prop("selected",true);
					    			curCusDate[1] = birthArr[di];
					    		}else if(dayfomat[di] == 'dd'){
					    			curCusDate[2] = birthArr[di];
					    		}else{
					    			curCusDate[0] = birthArr[di];
					    		}
					    	}
					    	$('#txtBoxBirthM').trigger('chosen:updated');
					    	$('input[name=birthDate]').val(curCusDate.join(''));
					    }
					}
				}
			}

			$(form.el).on('focusout', function(e) {
				const _this = e.target;
				const _id = _this.id;

				if (!$(_this).prop('required')) {
					return;
				}
				
				const emailAddrPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				switch (_id) {
					case 'txtBoxVerificationEmail':
						$(_this).val($.trim($(_this).val())) // LGEBR-1147 : 이메일 Trim() 이벤트 추가
						if ($(_this).val() == '' || $(_this).val() == null) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');			
							return;
						} else {
							showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
						}
			
						if (!emailAddrPattern.test($(_this).val()) || !lowerCheck($(_this).val())) {
							showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'invalid');			
							return;
						}

						if (typeof $(_this).attr('data-url') != 'undefined') {			
				
							const url = $(_this).attr('data-url');
							const param = {"emailAddr" : xssfilter($(_this).val()) , "snsFlag" : "Y"};
						
							$.ajax({
								type: 'post',
								url: url,
								data: param,
								dataType: 'json',
								xhrFields: {
									withCredentials: true
								},
								success: function(res) {

									// LGEPA-473 start : test
									if (res.error.code == "1009") {
										let _htm = "<form action='' id='"+ document.forms[0].id +"' method='post'>"
											_htm += "<fieldset>";
											_htm += "<input type='hidden' id='txtBoxVerificationEmail' name='emailAddr' value='"+res.error.mail+"'>";
											_htm += "<input type='hidden' id='txtBoxPassword' name='password' value='abc1234!@'>";
											_htm += "<input type='hidden' name='submitData' value='"+ JSON.stringify( res )+"'>";
											_htm += "<input type='hidden' name='serverEnv' value='"+$("#resendResetPasswordForm").find("input[name='serverEnv']").val()+"'>";
											_htm += "</fieldset>";
											_htm += "</form>";
											
										$('body').append(_htm);
										const form = document.forms;
										form.attr("action",$("#resendResetPasswordForm").attr("action").replace("/forgotPassword","/login"));
										form.submit();
										
										return;
									}
									// LGEPA-473 end

									if (res.error.code == "5001") {
										showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
									} else {
										showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'already');			
									}
								},
								error: function(request, status, error) {
									console.log(error);
								}
							});
						}
						break;
					case 'txtBoxPassword':
						if (!$(_this).attr('aria-describedby')) {
							if (($(_this).val() == '' || $(_this).val() == null)) {
								if ($(_this).parent().find('.error-msg').children('.guide-password').length > 0) {
    								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'guide-password');
    							} else {
    								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
    							}
							} else {
                                if ($(_this).parent().find('.error-msg').children('.guide-password').length > 0) {
    								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', 'guide-password');
    							}else{
    								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', 'required');	
                                }
							}
						}else{
							if ($(_this).parent().find('.error-msg').children('.guide-password').length > 0 && $('[name=countryCode]').val() == 'CA') {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'guide-password');
						    }
						}
						break;
					case 'txtBoxPasswordConfirm':
						if (!$(_this).attr('aria-describedby')) {
							if ($(_this).val() == '' || $(_this).val() == null) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', 'required');
							}
						}
						break;
					case 'txtBoxDocumentNumber':
							if ($(_this).val() == '' || $(_this).val() == null) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else if (!/^[0-9]+$/.test($(_this).val())) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required-num');
							} else if ($(_this).val().length != $(_this).attr('minlength')) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'min-length invalid');
							} else {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
							}
	
							break;
						// LGEBR-829 Start
						// citizenshipNo : submit -(ACCCommonCodes.SsoStatusCode.SIGN_UP_05 = 2005 > duplicated fail) + form-validation > fail 참고
						// cnpj_no : submit - form-validation > fail 참고
						// 단순 null(required) error 상태일 때만 null 체크 > msg element hide
						// showAndHideElements 함수 hide 사용 시, .error-msg 자체가 hide 되어 ajax msg(citizenshipNo) 버그 발생하여 미사용
					case 'citizenshipNo':
							if ($(_this).val().indexOf('_') != -1 || $(_this).val() == '' || $(_this).val() == null) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else if ($(_this).next('.error-msg').find('.required').is(':visible')) {
								$(_this).parent().find('.error-msg span').hide();
							}
							break;
					case 'cnpj_no':
							if ($(_this).val().indexOf('_') != -1 || $(_this).val() == '' || $(_this).val() == null) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else if ($(_this).next('.error-msg').find('.required').is(':visible')) {
								$(_this).parent().find('.error-msg span').hide();
							}
							break;
						// LGEBR-829 End
					//PJTJOINMEMBER-1 Start
					case 'txtBoxBirthY' :
						if($(_this).val() == '' || $(_this).val() == null) {
					        showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'required');
					    }else if(!/^[0-9]{1,4}$/.test($(_this).val())){
					        showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'invalid');
					    }else if( $('#txtBoxBirthD').val() != '' && $('#txtBoxBirthD').val() != null && $('#txtBoxBirthM option:selected').val() != '00'){
					    	const dateInfo = {
								year : 	$(_this).val(),
								month : $('#txtBoxBirthM option:selected').val(),
								day : $('#txtBoxBirthD').val()
							};
							dateInfo.day = parseInt(dateInfo.day) > 0 && parseInt(dateInfo.day) < 10 && dateInfo.day.length == 1 ? '0'+dateInfo.day : dateInfo.day;
					    	let checkBirth = dateInfo.year + dateInfo.month + dateInfo.day;
					    	
					        if(dateScope.dateValidation(checkBirth)){
					        	if(!dateScope.limitAgeCheck(dateInfo.year,dateInfo.month,dateInfo.day,limitAge)){
					        	    showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'limitAge');
					        	}else{
					        		$('input[name=birthDate]').val(checkBirth);
					        		showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'hide', 'required');
					        	}
					        }else{
					            showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'invalid');
					        }
					    }else{
					        showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'hide', 'required');
					    }
						break;
					case 'txtBoxBirthD' :
						if($(_this).val() == '' || $(_this).val() == null) {
					        showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'required');
					    }else if(!/^[0-9]{1,2}$/.test($(_this).val())){
					        showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'invalid');
					    }else if( $('#txtBoxBirthY').val() != '' && $('#txtBoxBirthY').val() != null && $('#txtBoxBirthM option:selected').val() != '00'){
					    	const dateInfo = {
								year : 	$('#txtBoxBirthY').val(),
								month : $('#txtBoxBirthM option:selected').val(),
								day : $(_this).val()
							};
							dateInfo.day = parseInt(dateInfo.day) > 0 && parseInt(dateInfo.day) < 10 && dateInfo.day.length == 1 ? '0'+dateInfo.day : dateInfo.day;
					    	let checkBirth = dateInfo.year + dateInfo.month + dateInfo.day;
					    	
					        if(dateScope.dateValidation(checkBirth)){
					        	if(!dateScope.limitAgeCheck(dateInfo.year,dateInfo.month,dateInfo.day,limitAge)){
					        	    showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'limitAge');
					        	}else{
					        		$('input[name=birthDate]').val(checkBirth);
					        		showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'hide', 'required');
					        	}
					        }else{
					            showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'show', 'invalid');
					        }
					    }else{
					        showAndHideElements($(_this).parent().parent().parent().find('.error-msg'), 'hide', 'required');
					    }
						break;
					case 'txtBoxMobilePhone' :
						if ($(_this).val() == '' || $(_this).val() == null) {
							if ($(_this).parent().find('.error-msg').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else {
								showAndHideElements($(_this).parent().parent().find('.error-msg'), 'show', 'required');
							}
							if($(_this).parent().parent().find('.input-info-text .full-text').length > 0){
								$(_this).parent().parent().find('.input-info-text .full-text').hide();
							}
						} else {
							if ($(_this).parent().find('.error-msg').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
							} else {
								showAndHideElements($(_this).parent().parent().find('.error-msg'), 'hide', '');
							}
							if($(_this).parent().parent().find('.input-info-text .full-text').length > 0){
								$(_this).parent().parent().find('.input-info-text .full-text').hide();
							}
						}
						break;
					//PJTJOINMEMBER-1 End
					default:
						if ($(_this).val() == '' || $(_this).val() == null) {
							if ($(_this).parent().find('.error-msg').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'show', 'required');
							} else {
								showAndHideElements($(_this).parent().parent().find('.error-msg'), 'show', 'required');
							}
						} else {
							if ($(_this).parent().find('.error-msg').length > 0) {
								showAndHideElements($(_this).parent().find('.error-msg'), 'hide', '');
							} else {
								showAndHideElements($(_this).parent().parent().find('.error-msg'), 'hide', '');
							}
						}
				}
			});
			//End LGEGMC-2112

			// LGECO-166 Start
			if(countryCode == 'CO') {
				$('#txtBoxRegion').change(function() {
					$.ajax({
						type: 'post',
						url: $('#txtBoxRegion').data('url'),
						data: { "addressLine1Info" : $(this).val() },
						dataType: 'json',
						xhrFields: {withCredentials: true},
						success: function(stateSata) {
							// console.log(stateSata);

							/*
							 * reset data
							 */
							$('#txtBoxCity').empty();
							$('#txtBoxCity').append('<option disabled selected value="">' + $('#txtBoxCity').data('placeholder') + '</option>');
							$('#txtBoxCity').trigger('chosen:updated');

							$('#txtBoxStateName').empty();
							$('#txtBoxStateName').append('<option disabled selected value="">' + $('#txtBoxStateName').data('placeholder') + '</option>');

							/*
							 * set option data
							 */
							stateSata.forEach(function(sdata, idx) {
								for (var key in sdata) {
									console.log(key + ' -> ' + sdata[key]);
									$('#txtBoxStateName').append('<option value="' + key + '">' + sdata[key] + '</option>');
								}
							});
							$('#txtBoxStateName').trigger('chosen:updated');
						},
						error: function(request, status, error) {
							console.log(error);
						}
					});
				});

				$('#txtBoxStateName').change(function() {
					$.ajax({
						type: 'post',
						url: $('#txtBoxStateName').data('url'),
						data: { "cityName" : $(this).val() },
						dataType: 'json',
						xhrFields: {withCredentials: true},
						success: function(cityData) {
							// console.log(cityData);

							/*
							 * reset data
							 */
							$('#txtBoxCity').empty();
							$('#txtBoxCity').append($('<option>', {
								value: '',
								text : $('#txtBoxCity').data('placeholder'),
								disabled: true,
								selected: true
							}));

							/*
							 * set option data
							 */
							cityData.forEach(function(cdata, idx) {
								for (var key in cdata) {
									console.log(key + ' -> ' + cdata[key]);
									$('#txtBoxCity').append($('<option>', {
										value: key,
										text : cdata[key]
									}));
								}
							});
							$('#txtBoxCity').trigger('chosen:updated');
						},
						error: function(request, status, error) {
							console.log(error);
						}
					});
				});
			}
			// LGECO-166 End
			/*$(form.el).on('change','#signUp-chk3, #signUp-chk4', function() {
				if($(this).prop('checked') == true){
					$(this).parents('p').next().addClass('show');
				}else{
					$(this).parents('p').next().removeClass('show');
				}
			});*/
			
			//PJTGPEMP-31
			
			//LGEIS-934 Start

			if (COUNTRY_CODE == 'it') {
		
				$signUpChk4 = $('input[id=signUp-chk4]');
				$signUpChk5 = $('input[id=signUp-chk5]');
				$signUpChk6 = $('input[id=signUp-chk6]');
		
				$signUpChk4.click(function() {		
				if(!$signUpChk4.prop("checked") == true){
							$signUpChk5.prop("checked", false).removeAttr("checked");
							$signUpChk6.prop("checked", false).removeAttr("checked");
						}
				})
				
				$signUpChk5.click(function() {		
				if($signUpChk5.prop("checked") == true){
							$signUpChk4.prop("checked", true).attr("checked");
							$signUpChk4.parents('label').next().addClass('show');
						}
				})
				 
				$signUpChk6.click(function() {		
				if($signUpChk6.prop("checked") == true){
							$signUpChk4.prop("checked", true).attr("checked");
							$signUpChk4.parents('label').next().addClass('show');
						}
				})
			}
			//LGEIS-934 End
			
			//LGEPL-656	start
			var $signUpChk = $('.sign-up-chk');
			$markChk = $signUpChk.find('input[id=signUp-chk4]');
			$markChk_1 = $signUpChk.find('input[id=signUp-chk1-1]');
			$markChk_2 = $signUpChk.find('input[id=signUp-chk2-2]');
			$markChk_3 = $signUpChk.find('input[id=signUp-chk3-3]');
			
			if( $markChk.length > 0){
				$markChk.click(function() {		
					if(!$markChk.prop("checked") == true){
						if( $markChk_1.length > 0)$markChk_1.prop("checked", false).removeAttr("checked");
						if( $markChk_2.length > 0)$markChk_2.prop("checked", false).removeAttr("checked");
						if( $markChk_3.length > 0)$markChk_3.prop("checked", false).removeAttr("checked");
					}else{
						if( $markChk_1.length > 0)$markChk_1.prop("checked", true).attr("checked");
						if( $markChk_2.length > 0)$markChk_2.prop("checked", true).attr("checked");
						if( $markChk_3.length > 0)$markChk_3.prop("checked", true).attr("checked");
					}
				})
			}

			if( $markChk.length > 0 && $markChk_1.length > 0){
				$markChk_1.click(function() {		
					if($markChk_1.prop("checked") == true){
						$markChk.prop("checked", true).attr("checked");
						//$markChk.parents('label').next().addClass('show');
					}
				});
			}
			
			if( $markChk.length > 0 && $markChk_2.length > 0){
				$markChk_2.click(function() {		
					if($markChk_2.prop("checked") == true){
						$markChk.prop("checked", true).attr("checked");
						//$markChk.parents('label').next().addClass('show');
					}
				});
			}

			if( $markChk.length > 0 && $markChk_3.length > 0){
				$markChk_3.click(function() {		
					if($markChk_3.prop("checked") == true){
						$markChk.prop("checked", true).attr("checked");
						//$markChk.parents('label').next().addClass('show');
					}
				});
			}
			//LGEPL-656	end
			
			if($('#nameType2').length) {
				$(document).on('change', 'input[id="nameType2"]', function (e) {
					let tempNo = $("input:hidden[name=customerNo]").val();
					$("input:hidden[name=customerNo]").val($("input:hidden[name=multiCustomerNo]").val());
					$("input:hidden[name=multiCustomerNo]").val(tempNo);
					
					let tempLo = $("input:hidden[name=defaultLocaleCode]").val();
					$("input:hidden[name=defaultLocaleCode]").val($("input:hidden[name=multiLocaleCode]").val());
					$("input:hidden[name=multiLocaleCode]").val(tempLo);						
				});
				$(document).on('change', 'input[id="nameType1"]', function (e) {
					let tempNo = $("input:hidden[name=customerNo]").val();
					$("input:hidden[name=customerNo]").val($("input:hidden[name=multiCustomerNo]").val());
					$("input:hidden[name=multiCustomerNo]").val(tempNo);
					
					let tempLo = $("input:hidden[name=defaultLocaleCode]").val();
					$("input:hidden[name=defaultLocaleCode]").val($("input:hidden[name=multiLocaleCode]").val());
					$("input:hidden[name=multiLocaleCode]").val(tempLo);		
			    });
			}
			
			// LGECI-824 LGEIS-978, LGEPL-656
			if(countryCode != 'CA_EN' && countryCode != 'CA_FR' && countryCode != 'IT' && countryCode != 'PL' && birthCheckFlag != true) {
				$(form.el).on('change',' .infoOpen', function() {
					if($(this).prop('checked') == true){
						$(this).parents('p').find('.chk-info').addClass('show');
					}else{
						$(this).parents('p').find('.chk-info').removeClass('show');
					}
				});
			}
			
			$(document).on('hidden.bs.modal', '#emailAddressDiff', function(e) {
				$('#txtBoxVerificationEmail').focus();
			});
			
			/* LGCOMEG-165 start */
			if ($('#signUp-chk-All').length) {
				$("#signUp-chk-All").click(function() {
					$('.sign-up-chk').find("input[type=checkbox]").prop("checked", $(this).prop("checked"));
					if($(".infoOpen").prop('checked') == true){
						$(".infoOpen").closest('p').find('.chk-info').addClass('show');
					} else {
						$(".infoOpen").closest('p').find('.chk-info').removeClass('show');
					}
				});
				
				$('.sign-up-chk').find("input[type=checkbox]").click(function() {
					if (!$(this).prop("checked")) {
						$("#signUp-chk-All").prop("checked", false);
					}
				});
			}
			/* LGCOMEG-165 end */
		}
	};

	form.init();
	//LGEPJTEMP-P1 
	if(document.forms[0].id == 'accountCombineForm') {
		if ($("#txtBoxVerificationEmail").length) { 
			$("#txtBoxVerificationEmail").bind("keyup", function() {
				$('#txtBoxVerificationEmail').val($('#txtBoxVerificationEmail').val().toLowerCase());
		    });	
		}
	}
	
	// 버튼 활성화
	function checkRequired(){
		let flag = true;
		$(form.el).find("[required]").each(function(){
			const val = $(this).val();
			if($(this).is("[type=checkbox]")) {
				if(!$(this).prop('checked')){
					flag = false;
				}
			}else {
				if(val == null || val.trim() == '') {
					flag = false;
				}
			}
			
		});
		return flag;
	}
	
	function lowerCheck(original){
		var lower = original.toLowerCase();
	    if(original != lower) {
	        return false;
	    }
	    return true;
	}
	
	$(form.el).on("propertychange change keyup paste input", function(e) {
		const condition = checkRequired();
		const submitBtn = $('.btn-area').find('button[type=submit]');
		
		if (condition) submitBtn.attr('disabled', false); 
		else submitBtn.attr('disabled', true); 
	});
	

	$(".accordion-wrap").on("click", ".link-text", function(){
		const $this = $(this);
		const $group = $this.closest(".accordion-group");
		if(!$group.hasClass("open")){
			$this.addClass("active");
			$this.attr('aria-expanded', true);
			$group.addClass("open").find(".accordion-content").stop().slideDown();
		}else{
			$this.removeClass("active");
			$this.attr('aria-expanded', false);
			$group.removeClass("open").find(".accordion-content").stop().slideUp();
		}
	})

	// LGEUK-124 Start 
	// Treasure Data Tracking
	let td_client_id_cookie = '';
	let td_global_id = '';
	let td_ssc_id = '';
	function getCookieTd(name) {
		if ($.cookie(name)) {
			return decodeURIComponent($.cookie(name));
		} else {
			$.cookie(name);
		}
	}
	function treasuredataInit(resultData, type, _this) {
	  	const tdLoginStatus = new Treasure({ // LGEITF-182
		    host: 'eu01.in.treasuredata.com',
			writeKey: resultData.apikey,
			database: resultData.database,
			sscDomain: 'lg.com',
			sscServer: 'ssc.lg.com',
			useServerSideCookie: true
		});

	  	tdLoginStatus.setSignedMode(); // LGEITF-182

		// Enable cross-domain tracking
		tdLoginStatus.set('$global', 'td_global_id', 'td_global_id'); // LGEITF-182
	    // Receive td_global_id
		const successCallback = function(td_global_id_data) {

			td_global_id = td_global_id_data;
			td_client_id_cookie = getCookieTd('_td');
			
			treasuredataAjax(resultData);
		
			// LGEITF-182 Start
			if(type != 'FAIL'){
				_this.submit();
			}
			// LGEITF-182 End
		};

		const errorCallback = function(err) {
			td_client_id_cookie = getCookieTd('_td');
			treasuredataAjax(resultData);
			
			// LGEITF-182 Start
			if(type != 'FAIL'){
				_this.submit();
			}
			// LGEITF-182 End
		};
		
		const successCallback_ssc = function (serverSideId) {
			td_ssc_id = serverSideId;
			console.log('successCallback_ssc');
			tdLoginStatus.fetchGlobalID(successCallback, errorCallback);
		};
		const errorCallback_ssc = function (error) {
			console.log('errorCallback_ssc :: ' + error);
		}
    	tdLoginStatus.fetchServerCookie(successCallback_ssc, errorCallback_ssc); // LGEITF-182

	}

	function treasuredataAjax(resultData){
		let treasuredataUrl = resultData.host; // LGEITF-421
			treasuredataUrl += resultData.database+ '/';
			treasuredataUrl += resultData.table+ '?';
			treasuredataUrl += 'td_write_key='+resultData.apikey;
			treasuredataUrl += '&td_client_id='+td_client_id_cookie;
			treasuredataUrl += '&td_global_id='+td_global_id;
			treasuredataUrl += '&td_ssc_id='+td_ssc_id;
		
			// LGEITF-182 Start
			if(resultData.timeSuccess)
				treasuredataUrl += '&time_success='+resultData.timeSuccess;
			if(resultData.typeSuccess)
				treasuredataUrl += '&type_success='+resultData.typeSuccess;
			if(resultData.typeLogin)
				treasuredataUrl += '&type_login='+resultData.typeLogin;
			if(resultData.typeSocial)
				treasuredataUrl += '&type_social='+resultData.typeSocial;
			if(resultData.lgeId)
				treasuredataUrl += '&lge_id='+resultData.lgeId;
			if(resultData.tdEmail)
				treasuredataUrl += '&email='+resultData.tdEmail;
			if(resultData.tdPhone)
				treasuredataUrl += '&phone='+resultData.tdPhone;
			if(resultData.nameFirst)
				treasuredataUrl += '&name_first='+resultData.nameFirst;
			if(resultData.nameLast)
				treasuredataUrl += '&name_last='+resultData.nameLast;
			if(resultData.sodialIdTwitter)
				treasuredataUrl += '&social_id_twitter='+resultData.sodialIdTwitter;
			if(resultData.screenNameTwitter)
				treasuredataUrl += '&screen_name_twitter='+resultData.screenNameTwitter;
			if(resultData.socialIdFb)
				treasuredataUrl += '&social_id_fb='+resultData.socialIdFb;
			if(resultData.nameFullFb)
				treasuredataUrl += '&name_full_fb='+resultData.nameFullFb;
			if(resultData.typeLoginResult)
				treasuredataUrl += '&type_login_result='+resultData.typeLoginResult;
			if(resultData.failMessage)
				treasuredataUrl += '&type_fail_reason='+resultData.failMessage;
			if(resultData.localeCode)
				treasuredataUrl += '&locale_code='+resultData.localeCode;
			if(resultData.corporationCode)
				treasuredataUrl += '&corporation_code='+resultData.corporationCode;
			if(resultData.cdpNameCode)
				treasuredataUrl += '&cdp_name_code='+resultData.cdpNameCode;
			if(resultData.cdpName)
				treasuredataUrl += '&cdp_name='+resultData.cdpName;
			if(resultData.tdTypeFail)
				treasuredataUrl += '&type_fail='+resultData.tdTypeFail;
			if(resultData.noPhoneNameReason)
				treasuredataUrl += '&no_phone_name_reason='+resultData.noPhoneNameReason;
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataUrl += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + resultData.socialIdEtc;
			// LGEITF-182 End

		if(cookieA && treasureDataFlag == 'Y'){
			$.ajax({
				url : treasuredataUrl,
				type : 'POST',
				dataType : 'jsonp',
				jsonpCallback: "callback",
				async: false,
				crossDomain: true,
				beforeSend: function (xhr) {
					xhr.setRequestHeader("Content-type","application/json");
					xhr.setRequestHeader("X-TD-Write-Key",resultData.apikey);
				},
				success : function(data){
					// console.log(data);
					console.log("treasuredata post success"); // LGEIN-239
				}
			});
		}
		
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		if(resultData.apikey)
			treasuredataInsertParam += 'td_write_key='+encodeURIComponent(resultData.apikey);
		if(td_client_id_cookie)
			treasuredataInsertParam += '&td_client_id='+encodeURIComponent(td_client_id_cookie);
		if(td_global_id)
			treasuredataInsertParam += '&td_global_id='+encodeURIComponent(td_global_id);
		if(td_ssc_id)
			treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent(td_ssc_id);
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}

	//LGCOMITF-123-2 start
	function nonTreasureDataInsertTable(resultData){
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		
		//Treasure Data 미사용국가들로 인해 해당데이터는 공백으로 넘겨짐. EDL 에서도 로그인 이력이 필요할뿐 Td 관련된 데이터는 필요 없음.
		treasuredataInsertParam += 'td_write_key='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_client_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_global_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent('N/A');
		
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	//LGCOMITF-123-2 end
	// function nvl(str, defaultStr){
	// 	let check = str+"";
	// 	let result = "";
	// 	check = check.trim()
	// 	if(check=="" || check==null || check == "null" || check=="undefined"){
	// 		result = defaultStr;
	// 	}else{
	// 		result = check;
	// 	}
	// 	return result ;
	// }
	// LGEUK-124 End

	//LGEKZ-103 start
	let isKZ = '';
	if (document.getElementById('serviceLocale')) {
		isKZ = document.getElementById('serviceLocale').value;  
	}

	if (isKZ == 'kz') {
		$('select[name=countryCode]').on('change', function() {
			$('.emp-email-certification').find('input').attr('disabled', false);
			$('.emp-verification-code').find('input').attr('disabled', false);
			$('input[name=password]').attr('disabled', false);
			$('input[name=passwordConfirm]').attr('disabled', false);
			$('input[name=firstName]').attr('disabled', false);
			$('input[name=lastName]').attr('disabled', false);
			$('input[name=birthDate]').attr('disabled', false);
			$('input[name=captchaCodeTextBox]').attr('disabled', false);
			$('input[name=policyAgreementFlag]').attr('disabled', false);
			$('input[name=emailAgreementFlag]').attr('disabled', false);
		});

		if ($('input[name=visitorcountry]').val() == 'KZ') {
			$('select[name=countryCode] option').each(function(index, element) {
				if (!(element.value == 'Select' || element.value == 'KZ')) {
					$(this).remove();
				}
			});
		}
	}
	//LGEKZ-103 end

	// LGEUK-366, LGEIN-531 Start
	let emailVerificationTimer;
	let emailVerificationSent = new Date(1970, 1, 1);
	let emailVerificationSentEmail = '';
	const emailCertification = $(".emp-email-certification");
	const emailCertificationCode = $('.emp-verification-code');
	if (emailCertification.find('input').length != 0) {
		emailCertification.find('.btn-send').click(function(verificationSendEvent) {
			const divErrorMsg = emailCertification.find('.error-msg');
	
			/* 이메일 형식 검사 */
			const verifyEmailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!verifyEmailPattern.test(emailCertification.find('input').val()) || !lowerCheck(emailCertification.find('input').val())) {
				showAndHideElements(divErrorMsg, 'show', 'invalid');
				return;
			}
			
			//PJTJOINMEMBER-3
			if(!emailCertificationV2){
				/* 메일 전송 확인 */
				const nowDateTime = Date.now();
				if (emailVerificationSent.getTime() == (new Date(1970, 1, 1)).getTime() && emailVerificationSentEmail == '') {
					emailVerificationSent.setTime(nowDateTime);
					emailVerificationSentEmail = emailCertification.find('input').val();
				} else {
					if ((nowDateTime - emailVerificationSent.getTime()) / 1000 < 60 && emailVerificationSentEmail == emailCertification.find('input').val()) {
						console.log('It\'s been less than a minute since the mail was sent.');
						showAndHideElements(divErrorMsg, 'show', 'wait-a-minute');
						return;
					}
					emailVerificationSent.setTime(nowDateTime);
					emailVerificationSentEmail = emailCertification.find('input').val();
				}
				
				/* 타이머 초기화 */
				clearInterval(emailVerificationTimer);
				$('.timer').text('00:00');
				
				/* 메시지를 초기화 */
				showAndHideElements(divErrorMsg, 'hide', '');
				showAndHideElements(emailCertificationCode.find('.ajax-msg'), 'hide', '');
				
				// 인증 문자 필드 초기화
				const verificationField = emailCertificationCode.find("input");
				const isFill = 0 < verificationField.val().length;
				if(isFill) verificationField.val("");
				
				/* inbox 버튼을 초기화 */
				if ($('.btn-goto-inbox').length != 0) {
					$('.btn-goto-inbox').remove();
				}
			}
			//PJTJOINMEMBER-3

			const reqUrl = emailCertification.find('input').attr('data-verification-url');
			/*PJTGPEMP-31 START*/
			let pageType = '';
			if(document.forms[0].id == 'accountCombineForm') pageType = 'combine';
			/*PJTGPEMP-31 END*/
			$.ajax({
				type: 'post',
				url: reqUrl,
				data: {
					emailAddr : emailCertification.find('input').val(),
					pageType : pageType
				},
				dataType: 'json',
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
	
					if(data.status == 'success') {
						if(data.multiCountryName) {
							multiCountryName = data.multiCountryName;
							multiCountryCode = data.multiCountryCode;
						}
						//PJTJOINMEMBER-3
						if(!emailCertificationV2){
							/* Resend로 변경 */
							let resendEmailBtnText = 'Resend Email';
							if (typeof $('.btn-send').data('alt-text') !== 'undefined') {
								resendEmailBtnText = $('.btn-send').data('alt-text');
							}
							
							$(verificationSendEvent.currentTarget).html(resendEmailBtnText);
							if ($(verificationSendEvent.currentTarget).hasClass("btn-primary")) {
								$(verificationSendEvent.currentTarget).removeClass("btn-primary");
								$(verificationSendEvent.currentTarget).addClass("btn-secondary");
							}
							showAndHideElements(divErrorMsg, 'show', 'notice email-sent');
							
							/* 타이머 작동 */
							verificationTimer(1 / 6);
							
							/* OK 버튼 활성화 */
							//emailCertificationCode.find('input').attr('disabled', false);
							// emailCertificationCode.find('button').attr('disabled', false);
							if (emailCertificationCode.find('button').prev().hasClass('confirmed')) {
								emailCertificationCode.find('button').prev().removeClass('confirmed');
							}
							
							emailCertificationCode.find('input').on('input', function(event){
								const isFill = 0 < event.target.value.length 
								emailCertificationCode.find('button').attr("disabled", isFill ? false : true);
							});
							
							/* GO TO INBOX 버튼 추가 */
							if (data.goToInboxUrl != '' && $('.btn-goto-inbox').length == 0) {
								let gotoInboxBtnText = 'GO TO INBOX';
								if (typeof $('.btn-send').data('inbox-text') !== 'undefined') {
									gotoInboxBtnText = $('.btn-send').data('inbox-text');
								}
								
								// Start LGEGMC-2339 (CA의 경우 버튼 스타일이 다름)
								let btnInboxClass = 'btn btn-primary btn-lg btn-goto-inbox';
								if ($('[name=countryCode]').val() == 'CA') {
									btnInboxClass = 'btn btn-primary btn-lg btn-send btn-block btn-goto-inbox';
								}
								// End LGEGMC-2339
								
								const gotoInboxBtn = $('<button />', {
									type: 'button',
									class: btnInboxClass,
									text: gotoInboxBtnText,
									on: {
										click: function (gotoInboxEvent) {
											window.open('http://' + data.goToInboxUrl);
											
											// emp에서 정의된 바 없음.
											// if ($(gotoInboxEvent.currentTarget).hasClass("btn-primary")) {
											// 	$(gotoInboxEvent.currentTarget).removeClass("btn-primary");
											// 	$(gotoInboxEvent.currentTarget).addClass("btn-outline-secondary");
											// }
											
											/* dataLayer */
											window.dataLayer.push({
												event: 'signup_goto_inbox'
											});
										}
									}
								});
								if ($('[name=countryCode]').val() == 'CA' && document.forms[0].id != 'accountCombineForm') {
									$('#divVerificationBtnArea').append(gotoInboxBtn);
								}else{
									emailCertification.find('.right-area').append(gotoInboxBtn);
								}
							} else {
							}
						}else{
							emailDupcheckResult = true;
							emailAddressDiffV2 = $('#txtBoxVerificationEmail').val();
							emailCertification.find('.ajax-msg').html(data.message).addClass('confirmed');
							showAndHideElements(emailCertification.find('.error-msg'), 'show', 'ajax-msg confirmed');
							emailCertification.find('.btn-send').attr('disabled', true);
							if(!!$('#encEmailAddr')) $('#encEmailAddr').val(btoa(emailAddressDiffV2));	// LGCOMBR-191
						}
						//PJTJOINMEMBER-3
						
					} else if (data.status == 'fail' && data.message == 'email duplicate') {
						showAndHideElements(divErrorMsg, 'show', 'already');
						if(emailCertificationV2) emailDupcheckResult = false; //PJTJOINMEMBER-3
					} else if (data.status == 'failToSign') { //PJTJOINMEMBER-3
						if(emailCertificationV2){
							emailDupcheckResult = false; 
							emailCertification.find('.error-msg').find('.ajax-msg').html(data.message);
							showAndHideElements(divErrorMsg, 'show', 'ajax-msg');
							$('#divEmailMoveToSignInBtn').on('click', function(e){
							    e.preventDefault();
							    window.location.href = $(this).data('goUrl');
							});
							emailCertification.find('.btn-send').attr('disabled', true);
							$('#divEmailMoveToSignInBtn').show();
						}
					} else if (data.status == 'fail') {
						emailCertification.find('.error-msg').find('.ajax-msg').html(data.message);
						showAndHideElements(divErrorMsg, 'show', 'ajax-msg');
						if(emailCertificationV2) emailDupcheckResult = false; //PJTJOINMEMBER-3
					} else {
					}
				},
				error: function(request, status, error) {
					console.log(error);
				}
			});
	
		});
		//PJTJOINMEMBER-3
		if(!emailCertificationV2){
			emailCertificationCode.find('button').click(function(verificationConfirmEvent) {
				/* 메시지를 초기화 */
				const divVerificationErrorMsg = emailCertificationCode.find('.error-msg');
				showAndHideElements(divVerificationErrorMsg, 'hide', '');
				
				const reqUrl = emailCertificationCode.find('input').attr('data-confirmation-url');
				//const param = 'emailAddr=' + emailCertification.find('input').val() + '&verificationCode=' + emailCertificationCode.find('input').val();
				$.ajax({
					type: 'post',
					url: reqUrl,
					data: {
						emailAddr : emailCertification.find('input').val(),
						verificationCode: emailCertificationCode.find('input').val()
					},
					dataType: 'json',
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						
						if(multiCountryName) {
							$('.multi-country-desc-message span').text(multiCountryName);
							$("input[name='multiCountryCode']").val(multiCountryCode);
						}
						
						/* display ajax message */
						if (emailCertificationCode.find('.ajax-msg').hasClass("confirmed")) {
							emailCertificationCode.find('.ajax-msg').removeClass("confirmed")
						}
						emailCertificationCode.find('.ajax-msg').html(data.message);
						showAndHideElements(divVerificationErrorMsg, 'show', 'ajax-msg');
						
						if(data.status == 'success') {
							/* 타이머 초기화 */
							clearInterval(emailVerificationTimer);
							$('.timer').text('00:00');
							
							/* Confirmed 비활성화 */
							emailCertificationCode.find('input').attr('disabled', true);
							$(verificationConfirmEvent.currentTarget).attr('disabled', true);
							emailCertificationCode.find('.ajax-msg').addClass('confirmed');
							
							$('#divVerificationBtnArea').hide();
							emailAddressDiff = $('#txtBoxVerificationEmail').val();
							
							/* 이메일 확인 결과 저장 */
							emailVerificationResult = true;
							
							/* Resend 버튼 숨김 */
							emailCertification.find('.btn-send').hide();
							
							/* 성공 후 이전 에러 메시지 초기화 */
							emailCertification.find('.error-msg').css('display','none');
							
							/* dataLayer */
							window.dataLayer.push({
								event: 'signup_pincode_check',
								checkResult: 'success'
							});
							
						} else {
							/* 이메일 확인 결과 저장 */
							emailVerificationResult = false;
							
							/* dataLayer */
							window.dataLayer.push({
								event: 'signup_pincode_check',
								checkResult: 'fail'
							});
						}
					},
					error: function(request, status, error) {
						console.log(error);
					}
				});
			});
		}
		//PJTJOINMEMBER-3
		emailCertification.find('input').on('change input', function() {
			//PJTJOINMEMBER-3
			if(!emailCertificationV2){
				/* 이메일이 변경되면 Resend 버튼 다시 보이도록 수정 */
				if(emailVerificationSentEmail !== $(this).val()) {
					emailCertification.find('.btn-send').show();
					emailCertificationCode.find('input').attr('disabled', false);
				}
			}else{
				emailDupcheckResult = false;
				emailCertification.find('.btn-send').attr('disabled', false);
				if(emailCertification.find('.ajax-msg').hasClass("confirmed")) {
					emailCertification.find('.ajax-msg').removeClass("confirmed")
				}
				if($('#divEmailMoveToSignInBtn').length > 0){
					$('#divEmailMoveToSignInBtn').hide();
				}
				emailCertification.find('.error-msg').css('display','none');
			}
			//PJTJOINMEMBER-3
		});
	}
	function verificationTimer(duration) {
		let timer = duration * 3600;
		let minutes, seconds;
	
		emailVerificationTimer = setInterval(function(){
			minutes = parseInt(timer / 60 % 60, 10);
			seconds = parseInt(timer % 60, 10);
	
			minutes = minutes < 10 ? "0" + minutes : minutes;
			seconds = seconds < 10 ? "0" + seconds : seconds;
	
			$('.timer').text(minutes + ":" + seconds);
	
			if (--timer < 0) {
				timer = 0;
				clearInterval(emailVerificationTimer);
				emailCertificationCode.find('button').attr('disabled', true);
			}
		}, 1000);
	}
	
	function showAndHideElements(targetObject, toggle, targetElement) {
		if(toggle == 'hide') {
			if(!targetElement) {
				// console.log(122, targetObject);
				targetObject['hide']();
			}
		} else {
			targetObject['show']();
		}
	
		targetObject.children().each(function (index, item) {
			const className = $(item).attr('class');
			if (className == targetElement) {
				$(item)[toggle == 'show' ? 'show' : 'hide']();
			} else {
				$(item).hide();
			}
		});
	}
	// LGEUK-366, LGEIN-531 End

	// EMP 20220215 START 이승혜 - sns-signup more detail 버튼(아코디언)
	$('.sns-sign-up-info button[aria-expanded]').on('click', function() {
		const $button = $(this);
		const $cont = $button.closest('.sns-sign-up-info').find('.sns-sign-up-info-cont');
		if ($cont.is(':visible')) {
			$button.attr('aria-expanded', false);
			$cont.stop().slideUp();
		} else {
			$button.attr('aria-expanded', true);
			$cont.stop().slideDown();
		}
	});
	// EMP 20220215 END 이승혜 

	const controlLabel = {
		el: null,
		inputs: null,
		init: function() {
			this.el = $('.signin-wrap.emp-type');
			if(this.el.length == 0) return false;
			this.inputs = this.el.find('.label-animation-input').find('>select');
			this.runEvent();
			this.bindEvent();
		},
		changeClass: function(el) {
			if(el.val() != '' && el.get(0).value != '' ) {
				el.addClass('inputted');
			} else {
				el.removeClass('inputted');
			}
		},
		runEvent: function() {
			this.inputs.each(function() {
				//console.log($(this), $(this).val());
				controlLabel.changeClass($(this));
			});
		},
		bindEvent: function() {
			this.inputs.on('keyup input', function() {
				controlLabel.changeClass($(this));
			});
		}
	}
	controlLabel.init();
	
	// show password, LGEBR-1275
	var passwordView =  function() {
        
        if(form.viewPasswordFlag != 'Y' && countryCode == 'BR'){
        	$('.password-util').addClass('d-none');
        }
        
        $('.btn-eyes').on('click', function(e){
        	var hide = $(this).parent().find('.txt-hide').text();
            var show = $(this).parent().find('.txt-show').text();
            var input = $(this).parent().parent().children('input');
            
    		e.preventDefault();
    		if($(this).hasClass('show')){
    			$(this).removeClass('show').attr('aria-label', hide);
    			input.attr('type', 'password');
    		}else{
    			$(this).addClass('show').attr('aria-label', show);
    			input.attr('type', 'text');
    		}
    		
    		$(this).focus();
    	});
    }
	passwordView();
	
	//PJTJOINMEMBER-3 add
	var signUpV2ResendInit = function(){
		var resendFlag = $('input[name=resendFlag]');
		var $resendModal = $('#errorResendModal');
		var resendTimeCheck =  function() {
			setTimeout(function(){
				$(resendFlag).val('N');
			}, 60000);
		}
		
		if($('.verify-btn .btn-secondary').length > 0){
			if($('.verify-btn .btn-secondary').attr('href') != ""){
				$(' .verify-btn').show();
			};
		}
		
		$(' .verify-resend a#resendMailV2').on('click', function(e) {
			e.preventDefault();
			
			if($(resendFlag).val() == 'N'){
				$(resendFlag).val('Y');
				resendTimeCheck();
				var resendReqUrl = $(' .verify-resend a#resendMailV2').data('resendUrl');
				
				$.ajax({
					type: 'post',
					url: resendReqUrl,
					data: {
						emailAddr : $('input[name=emailAddr]').val()
					},
					dataType: 'json',
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						if(data.status == 'success') {
							$resendModal.find('.modal-alert p').html($resendModal.data('defaultMessage'));
						} else if (data.status == 'fail') {
							$resendModal.find('.modal-alert p').html($resendModal.data('waitMessage'));
						}
						$resendModal.modal('show');
					},
					error: function(request, status, error) {
						console.log(error);
					}
				});
			}else{
				//resend email을 1분내에 다시 시도하는 경우, 오류메시지 팝업을 노출
				$resendModal.find('.modal-alert p').html($resendModal.data('waitMessage'));
				$resendModal.modal('show');
			}
			
		});
	}
	if($('input[name=signUpV2Complete]').length > 0){
		signUpV2ResendInit();
	}
	//PJTJOINMEMBER-1 add
	
	// LGEDE-1110 Start
	const simpleLayer = {
		init: function() {
			// copy content
			$('.layer-simple').each(function() {
				const contentId = $(this).data('content');
				if(contentId) {	
					const html = $('#'+contentId).html();
					if(html){
						$(this).find('.layer-content').html(xssfilter(html, true));
					}
				}
			});
			// button event
			const $toggleBtn = $('.js-toggle-simplelayer');
			$toggleBtn.off().on('click', function(event) {
				event.preventDefault();
				const layerid = $(this).attr('aria-controls');
				const $layer = $('#' + layerid);
				// show the layer
				$('.layer-simple').removeClass('active');
				$layer.addClass('active');
				const layerHeight = parseInt($layer.outerHeight()) + 40;
				const windowHeight = $(window).height();
				if(layerHeight > windowHeight) {
					$layer.addClass('full');
				}
				$('body').addClass('modal-open');
				// set top-arrow's position
				const layerPosLeft = $(this).offset().left + ($(this).width()/2) - $layer.offset().left;
				$layer.find('.arrow-top').css({
					left: layerPosLeft
				});
				$layer.find('button.close').off().on('click', function() {
					$layer.removeClass('active');
					$layer.removeClass('full');
					$('body').removeClass('modal-open');
				});
			});
		}
	};
	simpleLayer.init();
	// LGEDE-1110 End
	
});
